<ciphr-collection-filter-header [attr.data-test-id]="filter().key" />
@if (expanded()) { <chr-datepicker [clearable]="true" [value]="selectedValue()" (change)="setValueSelection($event)" /> }
